import * as React from "react";

import { Field, FieldWrapper } from "@progress/kendo-react-form";
import { TextArea } from "@progress/kendo-react-inputs";
import { Error, Hint, Label } from "@progress/kendo-react-labels";

const FormTextArea = (fieldRenderProps) => {
  const {
    validationMessage,
    touched,
    label,
    id,
    valid,
    disabled,
    hint,
    type,
    optional,
    name,
    ...others
  } = fieldRenderProps;
  let idOrName = name || id;
  const showValidationMessage = touched && validationMessage;
  const showHint = !showValidationMessage && hint;
  const hindId = showHint ? `${idOrName}_hint` : "";
  const errorId = showValidationMessage ? `${idOrName}_error` : "";

  return (
    <FieldWrapper>
      <Label
        className="k-floating-label"
        editorId={idOrName}
        editorValid={valid}
        editorDisabled={disabled}
        optional={optional}
        style={{
          fontWeight: 300,
          color: "#757575",
          fontSize: "0.8rem",
          margin: 0,
        }}
      >
        {label}
      </Label>
      <div className={"k-form-field-wrap"}>
        <TextArea
          valid={valid}
          type={type}
          id={idOrName}
          name={idOrName}
          disabled={disabled}
          rows={4}
          ariaDescribedBy={`${hindId} ${errorId}`}
          {...others}
        />
        {showHint && <Hint id={hindId}>{hint}</Hint>}
        {showValidationMessage && (
          <Error id={errorId}>{validationMessage}</Error>
        )}
      </div>
    </FieldWrapper>
  );
};

export { FormTextArea };

export function FieldFormTextArea(params) {
  return <Field component={FormTextArea} {...params} />;
}
